import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'mr0014',
    ecrans: ['00-2'],
    params: [
        '?stamnetabcri',
        '?cleintcri'
    ]
});
